import { lazyNamed } from 'src/utils/lazyNamed';

const TagDetails = {
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  DisableRuleList: lazyNamed(() => import('./containers/DisableRuleList'), 'DisableRuleList'),
  DynamicPlacementsList: lazyNamed(() => import('./containers/DynamicPlacementsList'), 'DynamicPlacementsList'),
  DynamicPlacementHistory: lazyNamed(() => import('./containers/DynamicPlacementHistory'), 'DynamicPlacementHistory'),
  PlacementsList: lazyNamed(() => import('./containers/PlacementsList'), 'PlacementsList'),
  Placement: lazyNamed(() => import('./containers/Placement'), 'Placement'),
  PlacementHistory: lazyNamed(() => import('./containers/PlacementHistory'), 'PlacementHistory'),
  Changelog: lazyNamed(() => import('./containers/Changelog'), 'Changelog'),
  BiddersAssign: lazyNamed(() => import('./containers/BiddersAssign'), 'BiddersAssign'),
  RawScriptsList: lazyNamed(() => import('./containers/RawScriptsList'), 'RawScriptsList'),
  FloorRule: lazyNamed(() => import('./containers/FloorRule'), 'FloorRule'),
  FloorRuleHistory: lazyNamed(() => import('./containers/FloorRuleHistory'), 'FloorRuleHistory'),
  RealtimeAnalytics: lazyNamed(() => import('./containers/RealtimeAnalytics'), 'RealtimeAnalytics'),
  PlacementLive: lazyNamed(() => import('./containers/PlacementLive'), 'PlacementLive'),
  PlacementLayout: lazyNamed(() => import('./components/PlacementLayout'), 'PlacementLayout'),
  Logbook: lazyNamed(() => import('./containers/Logbook'), 'Logbook'),
};

export default TagDetails;
